/**
 * Stable, machine-readable codes for the few errors that the frontend needs to
 * branch on. Keep this enum minimal: only add a code when there's a concrete
 * consumer (`error.code === ErrorCode.X`) AND a concrete producer.
 *
 * - `REAUTHENTICATION_REQUIRED` — thrown from the auth middleware when token
 *   acquisition fails. Signals that `forceReauthentication()` is already in
 *   flight; any catch block seeing this should just re-throw or let it bubble.
 * - `DB_ACCESS_MISSING` — the current user has no database access. Consumed by
 *   `app-splash-screen.vue` to load a dedicated "no databases" error screen.
 * - `UNEXPECTED` — catch-all / fallback. Used as the default when we don't
 *   have a more specific code, and by `mapToAppError` for anything non-AppError.
 */
export enum ErrorCode {
  REAUTHENTICATION_REQUIRED = 'AUTH.REAUTHENTICATION_REQUIRED',
  DB_ACCESS_MISSING = 'ACCESS.DB_ACCESS_MISSING',
  UNEXPECTED = 'SYSTEM.UNEXPECTED'
}
